import * as React from 'react';
import {
    getReactAccordion,
    getReactButton,
    getReactCheckbox,
    getReactHierarchicalList, getReactInput,
    getReactLink,
    ReactInput
} from "../../index";
import {RefObject, useCallback} from "react";
import {ReactButtonState} from "./ReactButton";
import {ReactInputData} from "./ReactInput";
import {ReactTableData, ReactTableState} from "./ReactTable";
import {ReactLinkState} from "./ReactLink";
import {data} from "jquery";

export interface HierarchicalCellData {
    className?: string,
    style?: {},
    displayValue?: any,
    displayOverride?: (rowObj: any, hierarchyIndex: number, disabled: boolean, levelCount: number) => {},
    row?: any,
    hierarchyIndex?: number,
    title?: string,
    disabled?: boolean,
    levelCount?: number,
}

class ReactHierarchicalCell extends React.Component<HierarchicalCellData> {
    constructor(props: HierarchicalCellData) {
        super(props);
    }

    getCell() {
        if((null != this.props.displayOverride)) {
            return this.props.displayOverride(this.props.row, this.props.hierarchyIndex, this.props.disabled, this.props.levelCount);
        } else if(this.props.title) {
            return <div className={this.props.className} style={this.props.style} title={this.props.title}>{this.props.displayValue}</div>;
        } else {
            return <div className={this.props.className} style={this.props.style}>{this.props.displayValue}</div>;
        }
    }

    render() {
        return this.getCell();
    }
}

interface CountData {
    childCount: number,
}

interface ReactHierarchicalRowData {
    row: any,
    id?: string,
    hierarchyIndex?: number,
    rowClass?: string,
    rowStyle?: {},
    deleteButtonTabIndex?: null,
    sortColumnIndex?: number, // -1 to add to the end
    addSelectColumn?: boolean,
    selectColumnIndex?: number, // -1 to add to the end
    onRowClick?: (rowOBJ: any, shiftKey: boolean, ctrlKey: boolean, hierarchyIndex: number, isRowClick: boolean) => void,
    onRowRightClick?: (rowOBJ: any, shiftKey: boolean, ctrlKey: boolean, hierarchyIndex: number) => void,
    deleteColumnIndex?: number, // -1 to add to the end
    onDelete?: (rowOBJ: any, shiftKey: boolean, ctrlKey: boolean, hierarchyIndex: number) => void,
    selectColumns?: [],
    css?: string,
    style?: {},
    selectRecordWithRowClick?: boolean,
    displayOverride?: (rowObj: any, hierarchyIndex: number, disabled: boolean, levelCount: number) => {},
    displayValue?: string,
    stopPropagationOnClick?: boolean,
    hightlightSelectedRowCSS?: (row: any, hierarchyIndex: number) => string,
    rowAdditionalAttributes?: (row: any, hierarchyIndex: number) => {},
    doHighlightRow?: boolean,
    tabIndex?: number,
    rowReference?: RefObject<any>,
    disabled?: boolean,
    addDeleteButton?: boolean,
    addSortIcon?: boolean,
    addDropIcon?: boolean,
    deleteButtonID?: string,
    shouldRowUpdate?: (nextRow: any, row: any, rowIndex: number) => boolean,
    levelCount?: number,
}

class ReactHierarchicalRow extends React.Component<ReactHierarchicalRowData> {
    constructor(props: ReactHierarchicalRowData) {
        super(props);

        // Binding is necessary to allow these functions access to the State data
        this.onRowClick = this.onRowClick.bind(this);
        this.onRowRightClick = this.onRowRightClick.bind(this);
        this.onDelete = this.onDelete.bind(this);
    }

    shouldComponentUpdate(nextProps: Readonly<ReactHierarchicalRowData>, nextState: Readonly<{}>, nextContext: any): boolean {
        if(null != this.props.shouldRowUpdate) {
            return this.props.shouldRowUpdate(nextProps.row, this.props.row, nextProps.hierarchyIndex);
        } else {
            return nextProps.row != this.props.row ||
                nextProps.doHighlightRow != this.props.doHighlightRow ||
                nextProps.disabled != this.props.disabled ||
                nextProps.css != this.props.css ||
                nextProps.style != this.props.style ||
                nextProps.rowClass != this.props.rowClass ||
                nextProps.rowStyle != this.props.rowStyle
                ;
        }
    }

    onRowClick(event: any) {
        if(null != this.props.onRowClick) {
            this.props.onRowClick(this.props.row, event.shiftKey, event.ctrlKey, this.props.hierarchyIndex, true);
        }
        if(this.props.stopPropagationOnClick) {
            event.stopPropagation();
        }
    }

    onRowRightClick(event: any) {
        event.preventDefault();

        if(null != this.props.onRowRightClick) {
            this.props.onRowRightClick(this.props.row, event.shiftKey, event.ctrlKey, this.props.hierarchyIndex);
        }
    }

    onDelete(event: React.MouseEvent<HTMLButtonElement, MouseEvent>) {
        if(null != this.props.onDelete) {
            this.props.onDelete(this.props.row, event.shiftKey, event.ctrlKey, this.props.hierarchyIndex);
        }
        event.stopPropagation();
    }

    getDeleteCell(id: string) {
        return <div id={(id + '_delete')} className={(this.props.addDeleteButton) ? "align-obj-center" : "align-obj-center categoryAllHide"}>
            <button id={(this.props.deleteButtonID.length > 0) ? (this.props.deleteButtonID + '_' + this.props.hierarchyIndex) : (id + '_deleteButton')} tabIndex={this.props.deleteButtonTabIndex} className={"ui-button ui-corner-all ui-widget ui-button-icon-only" + ((this.props.disabled) ? " ui-button-disabled ui-state-disabled" : "")} onClick={this.onDelete} type="button" disabled={this.props.disabled} >
                <span className="ui-button-icon ui-icon ui-icon-circle-close"></span>
                <span className="ui-button-icon-space"> </span>
            </button>
        </div>;
    }

    getSortCell(id: string) {
        return <div id={(id + '_sort')} className={(this.props.addSortIcon) ? "align-obj-center" : "align-obj-center categoryAllHide"}>
            <i className={'fas fa-bars ui-sortable movable manualSort' + ((this.props.disabled) ? " ui-button-disabled ui-state-disabled" : "")} ></i>
        </div>;
    }

    getDropCell(id: string) {
        return <div id={(id + '_drop')} className={(this.props.addDropIcon) ? "align-obj-center" : "align-obj-center categoryAllHide"}>
            <i className={'fas fa-reply ui-sortable movable manualSort' + ((this.props.disabled) ? " ui-button-disabled ui-state-disabled" : "")} ></i>
        </div>;
    }

    render() {
        const rowHighlightClass = (null != this.props.hightlightSelectedRowCSS) ? this.props.hightlightSelectedRowCSS(this.props.row, this.props.hierarchyIndex) : 'copia_color3_b nowrap';
        const rowClasses = (this.props.doHighlightRow) ? (' ' + rowHighlightClass) : '';
        const rowAdditionalAttributes = (null != this.props.rowAdditionalAttributes) ? this.props.rowAdditionalAttributes(this.props.row, this.props.hierarchyIndex) : {};

        return <div data-hierarchyIndex={this.props.hierarchyIndex} data-hierarchyLevel={this.props.levelCount} id={this.props.id} ref={this.props.rowReference} style={this.props.style} className={this.props.css + rowClasses} onClick={this.onRowClick} onContextMenu={this.onRowRightClick} {...rowAdditionalAttributes}>
            <ReactHierarchicalCell
                row={this.props.row}
                hierarchyIndex={this.props.hierarchyIndex}
                displayValue={this.props.displayValue}
                displayOverride={this.props.displayOverride}
                style={this.props.rowStyle}
                className={this.props.rowClass}
                disabled={this.props.disabled}
                levelCount={this.props.levelCount}
            />
            {this.getSortCell(this.props.id)}
            {this.getDropCell(this.props.id)}
            {this.getDeleteCell(this.props.id)}
        </div>;
    }
}

interface ReactHierarchicalListData {
    id?: string,
    hierarchyKey?: string,
    style?: {},
    css?: string,
    divContainerCSS?: string,
    divContainerStyle?: {},
    collapsedStyle?: {},
    collapsedCSS?: string,
    expandedCSS?: string,
    expandedStyle?: {},
    contentStyle?: (row: any, rowIndex: number) => {},
    contentCSS?: string,
    dataKey: string,
    rows: any[], // All Rows
    tabIndex?: null,
    refreshID?: string,
    onRefresh?: () => {},
    expandedID?: string,
    stopPropagationOnClick?: boolean,
    disabled?: boolean,
    disableID?: string,
    rowID?: string,
    deleteButtonID?: string,
    hiddenTotalCountID?: string,
    arrowExpandCSS?: string,
    arrowCollapseCSS?: string,
    arrowStyle?:  (row: any, rowIndex: number) => {},
    displayOverride: (rowObj: any, hierarchyIndex: number, disabled: boolean) => {},
    hierarchyPagingArrowDisplayOverride: (rowObj: any, hierarchyIndex: number, pageDown: boolean, disabled: boolean, levelCount: number) => {},
    contentOverride: (rowObj: any, hierarchyIndex: number, disabled: boolean) => {},
    displayKey: string,
    isSelectedKey: string,
    highlightOnClick?: boolean,
    hightlightSelectedRowCSS?: (row: any, hierarchyIndex: number) => string,
    rowAdditionalAttributes?: (row: any, hierarchyIndex: number) => {},
    rowsCSS?: (row: any, rowIndex: number) => string,
    rowsStyle?: (row: any, rowIndex: number) => {},
    onRowClick?: (rowObj: any, shiftKey: boolean, ctrlKey: boolean, hierarchyIndex: number, parentRowObj: any, indexInParent: number, selectedRows: any[]) => boolean,
    onRowRightClick?: (rowOBJ: any, shiftKey: boolean, ctrlKey: boolean, hierarchyIndex: number, parentRowObj: any, indexInParent: number, selectedRows: any[]) => boolean,
    onRowDelete?: (rowObj: any, shiftKey: boolean, ctrlKey: boolean, hierarchyIndex: number, parentRowObj: any, indexInParent: number) => boolean,
    onAfterRowDelete?: () => void,
    onKeyDown?: (rowOBJ: any, keyPressed: string, hierarchyIndex: number, bShift: boolean, bCTRL: boolean, bALT: boolean, selectedRows: any[]) => void,
    onKeyUp?: (rowOBJ: any, keyPressed: string, hierarchyIndex: number, bShift: boolean, bCTRL: boolean, bALT: boolean) => void,
    addDeleteButton?: boolean,
    addSortIcon?: boolean,
    addDropIcon?: boolean,
    deleteButtonTabIndex?: null,
    enableDragAndDrop?: boolean,
    allowDrag?: (rowObj: any, parentObj: any) => boolean,
    allowDrop?: (rowObj: any, parentObj: any) => boolean,
    onDropEvent?: (event: any) => void,
    enableUnboundDragAndDrop?: boolean,
    allowDropToTheBottom?: boolean,
    allowExpandAndCollapse?: (row: any, rowIndex: number) => boolean,
    shouldRowUpdate?: (nextRow: any, row: any, rowIndex: number) => boolean,
    initialRowSelected?: string,
    initialRowsSelected?: string[],
    hierarchyNumToDisplay?: number,
    rowKey?: string,
    onFocusEndKeyPressEvent?: (row: any, keyPressed: string, bShift: boolean, bCTRL: boolean) => null,
    allowFocusOnRow?: (row: any, bShift: boolean, bCTRL: boolean, onClick: boolean, onRightClick: boolean) => null,
    leftOfArrowContent?: (row: any, rowIndex: number, disabled: boolean, doHighlight: boolean) => any,
    overrideScrollIntoView?: (row: any, highlightKey: string) => void,
    scrollWithScrollBarAfterPaging?: boolean,
    stopPropagationOnKeyPress?: (rowOBJ: any, rowIndex: number, keyPressed: string, bOnKeyUp: boolean, bShift: boolean, bCTRL: boolean, bALT: boolean) => boolean,
    onCollapseExpandAccordion?: (rowObj: any, rowIndex: number, shiftKey: boolean, ctrlKey: boolean) => boolean,
    enableMultiSelect?: boolean,
    selectRecordsWithRowDrag?: boolean,
}

interface HierarchyIndexData {
    runningCount: number
}

interface HierarchyLevelData {
    rowKey: string,
    parentKey: string,
    level: number,
    index: number,
}

interface HierarchyPagingData {
    hierarchyKey: string,
    startPos: number,
}

interface ReactHierarchicalListState {
    rows: any[],
    highlightSelectedRow: any,
    disabled: boolean,
    rowCount: number,
    rowIsDragging: boolean,
    highlightKey: string,
    selectedHierarchyLevelData: HierarchyLevelData[];
    updatedPagingData: HierarchyPagingData[];
    rowIsClicked: boolean,
    highlightMultipleKeys: string[],
}

export class ReactHierarchicalList extends React.Component<ReactHierarchicalListData> {
    totalRows: any[];
    foundPrevRow: boolean;
    foundCurrentRow: boolean;
    returnNextRow: boolean;
    foundParentRow: boolean;
    highlightRowRef: RefObject<any>;
    currentPagingData: HierarchyPagingData[];
    lastSelectedRow: any;

    constructor(props: ReactHierarchicalListData) {
        super(props);

        this.highlightRowRef = React.createRef();
        this.totalRows = [];
        this.foundPrevRow = false;
        this.returnNextRow = false;
        this.foundParentRow = false;
        this.foundCurrentRow = false;
        this.currentPagingData = [];

        let canSelectInitialRow = null != props.initialRowSelected && null != this.props.rowKey;
        let localHighlightKey: string = '';
        let highlightMultipleKeys: string[] = [];
        let localSelectedHierarchyLevelData: HierarchyLevelData[] = [];
        if(canSelectInitialRow) {
            this.lastSelectedRow = props.initialRowSelected;
            localHighlightKey = props.initialRowSelected;
            highlightMultipleKeys = props.initialRowsSelected;
            localSelectedHierarchyLevelData = this.getHierarchyLevelData(localHighlightKey, "-1", 0, props.rows);
        }

        this.state = {
            rows: props.rows,
            highlightSelectedRow: (canSelectInitialRow) ? this.getHighlightRow(props.rows, localHighlightKey) : null,
            disabled: props.disabled,
            rowIsDragging: false,
            highlightKey: localHighlightKey,
            selectedHierarchyLevelData: localSelectedHierarchyLevelData,
            updatedPagingData: [],
            rowIsClicked: false,
            highlightMultipleKeys: highlightMultipleKeys,
        };

        // Binding is necessary to allow these functions access to the State data
        this.onRefresh = this.onRefresh.bind(this);
        this.onClick = this.onClick.bind(this);
        this.onDelete = this.onDelete.bind(this);
        this.onKeyDown = this.onKeyDown.bind(this);
        this.onKeyUp = this.onKeyUp.bind(this);
        this.onRightClick = this.onRightClick.bind(this);
        this.onDisableClick = this.onDisableClick.bind(this);
        this.onDrop = this.onDrop.bind(this);
        this.onDragHandler = this.onDragHandler.bind(this);
        this.onDragStartHandler = this.onDragStartHandler.bind(this);
        this.highlightRow = this.highlightRow.bind(this);
        this.updateManualPageIndex = this.updateManualPageIndex.bind(this);
        this.getAccordionPagingRow = this.getAccordionPagingRow.bind(this);
        this.getSelectedRow = this.getSelectedRow.bind(this);
        this.onRowScroll = this.onRowScroll.bind(this);
        this.executeScroll = this.executeScroll.bind(this);
    }

    // Update the state externally
    componentWillReceiveProps (props: ReactHierarchicalListData) {
        this.totalRows = [];
        this.foundPrevRow = false;
        this.returnNextRow = false;
        this.foundParentRow = false;
        this.foundCurrentRow = false;

        if ((null != props.initialRowSelected || null != props.initialRowsSelected) && null != this.props.rowKey) {
            let localHighlightKey = props.initialRowSelected;
            let localSelectedHierarchyLevelData = this.getHierarchyLevelData(localHighlightKey, "-1", 0, props.rows);
            let highlightMultipleKeys = props.initialRowsSelected;

            this.setState({
                rows: props.rows,
                highlightKey: localHighlightKey,
                selectedHierarchyLevelData: localSelectedHierarchyLevelData,
                highlightSelectedRow: this.getHighlightRow(props.rows, localHighlightKey),
                updatedPagingData: (this.state as ReactHierarchicalListState).updatedPagingData,
                highlightMultipleKeys: highlightMultipleKeys,
            });
        } else {
            this.setState({
                rows: props.rows,
                highlightSelectedRow: null,
            });
        }
    }

    getHighlightRow(rows: any[], key: string):any|null {
        for(let i = 0; i < rows.length; i++) {
            if(rows[i][this.props.rowKey] == key) {
                return rows[i];
            } else {
                if(null != rows[i][this.props.hierarchyKey] && rows[i][this.props.hierarchyKey].length > 0) {
                    const returnRow = this.getHighlightRow(rows[i][this.props.hierarchyKey], key);
                    if(null != returnRow) {
                        return returnRow;
                    }
                }
            }
        }

        return null;
    }

    highlightRow(event: any) {
        const localHighlightKey = $(event.currentTarget).val() + "";
        if(localHighlightKey != "") {

            let localSelectedHierarchyLevelData: HierarchyLevelData[] = [];
            if(null != this.props.rowKey) {
                localSelectedHierarchyLevelData = this.getHierarchyLevelData(localHighlightKey, "-1", 0, (this.state as ReactHierarchicalListState).rows);
            }

            this.setState(() => {
                return {
                    rows: (this.state as ReactHierarchicalListState).rows,
                    highlightKey: localHighlightKey,
                    selectedHierarchyLevelData: localSelectedHierarchyLevelData,
                    highlightSelectedRow: this.getHighlightRow((this.state as ReactHierarchicalListState).rows, localHighlightKey),
                    rowIsClicked: false,
                }
            }, () => {
                this.executeScroll();
            });
        }
    }

    getSelectedRow(rows: any[], indexToSelect: number, indexData: HierarchyIndexData):any {
        let loopIndex = 0;
        while(loopIndex < rows.length) {
            if(indexData.runningCount == indexToSelect) {
                return rows[loopIndex];
            }

            indexData.runningCount++;

            const children = rows[loopIndex][this.props.hierarchyKey];
            if(null != children && children.length > 0) {
                const returnRow = this.getSelectedRow(children, indexToSelect, indexData);
                if(null != returnRow) {
                    return returnRow;
                }
            }
            loopIndex++;
        }

        return null;
    }

    selectRow(rows: any[], row: any, maintainSelection: boolean, selectInbetween: boolean, startSelection: boolean) {
        let startSelecting = startSelection;
        for(let i = 0; i < rows.length; i++) {
            if(selectInbetween && null != this.lastSelectedRow) {
                if(rows[i] == row || rows[i] == this.lastSelectedRow) {
                    rows[i][this.props.isSelectedKey] = true;

                    if(selectInbetween) {
                        if(!startSelecting) {
                            startSelecting = true;
                        } else {
                            startSelecting = false;
                        }
                    }
                } else if(startSelecting) {
                    rows[i][this.props.isSelectedKey] = true;
                }
            } else if(maintainSelection) {
                if(rows[i] == row) {
                    rows[i][this.props.isSelectedKey] = !rows[i][this.props.isSelectedKey];
                }
            } else {
                rows[i][this.props.isSelectedKey] = (rows[i] == row);
            }

            if(null != rows[i][this.props.hierarchyKey] && rows[i][this.props.hierarchyKey].length > 0) {
                startSelecting = this.selectRow(rows[i][this.props.hierarchyKey], row, maintainSelection, selectInbetween, startSelecting);
            }
        }
        return startSelecting;
    }

    selectRowOnDrag(rows: any[], dragOverRow: any, startSelection: boolean) {
        let startSelecting = startSelection;
        for (let i = 0; i < rows.length; i++) {
            if (rows[i] == dragOverRow || rows[i] == this.lastSelectedRow) {
                if(dragOverRow != this.lastSelectedRow) {
                    startSelecting = !startSelecting;
                }
                rows[i][this.props.isSelectedKey] = true;
            } else if(startSelecting) {
                rows[i][this.props.isSelectedKey] = true;
            }
            if(null != rows[i][this.props.hierarchyKey] && rows[i][this.props.hierarchyKey].length > 0) {
                startSelecting = this.selectRowOnDrag(rows[i][this.props.hierarchyKey], dragOverRow, startSelecting);
            }
        }
        return startSelecting;
    }

    clearSelection(rows: any[]) {
        for (let i = 0; i < rows.length; i++) {
            rows[i][this.props.isSelectedKey] = false;
            if(null != rows[i][this.props.hierarchyKey] && rows[i][this.props.hierarchyKey].length > 0) {
                this.clearSelection(rows[i][this.props.hierarchyKey]);
            }
        }
    }

    getSelectedRowKeys(rows: any[]) {
        let selectedKeys: string[] = [];
        for(let i = 0; i < rows.length; i++) {
            if(rows[i][this.props.isSelectedKey]) {
                selectedKeys.push(rows[i][this.props.rowKey]);
            }
            if(null != rows[i][this.props.hierarchyKey] && rows[i][this.props.hierarchyKey].length > 0) {
                const newRows = this.getSelectedRowKeys(rows[i][this.props.hierarchyKey]);
                for (let j = 0; j < newRows.length; j++) {
                    selectedKeys.push(newRows[j]);
                }
            }
        }
        return selectedKeys;
    }

    getSelectedRows(rows: any[]) {
        let selectedRows: any[] = [];
        for(let i = 0; i < rows.length; i++) {
            if(rows[i][this.props.isSelectedKey]) {
                selectedRows.push(rows[i]);
            }
            if(null != rows[i][this.props.hierarchyKey] && rows[i][this.props.hierarchyKey].length > 0) {
                const newRows = this.getSelectedRows(rows[i][this.props.hierarchyKey]);
                for (let j = 0; j < newRows.length; j++) {
                    selectedRows.push(newRows[j]);
                }
            }
        }

        return selectedRows;
    }

    getParentRow(rows: any[], row: any, parentRow: any):any {
        for(let i = 0; i < rows.length; i++) {
            if(this.foundParentRow) {
                return parentRow;
            } else if(row == null) {
                return rows[i];
            } else if(rows[i] == row) {
                this.foundParentRow = true;
                return parentRow;
            }

            if(null != rows[i][this.props.hierarchyKey] && rows[i][this.props.hierarchyKey].length > 0) {
                const tempParent = this.getParentRow(rows[i][this.props.hierarchyKey], row, rows[i]);
                if(this.foundParentRow) {
                    return tempParent;
                }
            }
        }

        return parentRow;
    }

    rowCanExpand(row: any):boolean {
        if(null == row) {
            return false;
        }
        if(null == row[this.props.hierarchyKey]) {
            return false;
        }
        if(row[this.props.hierarchyKey].length <= 0) { // Has no children
            return false;
        }

        const dataKey = (null != this.props.dataKey) ? this.props.dataKey : "isExpanded";
        return (null == row[dataKey] || !row[dataKey]);
    }

    rowCanCollapse(row: any):boolean {
        if(null == row) {
            return false;
        }
        if(null == row[this.props.hierarchyKey]) {
            return false;
        }
        if(row[this.props.hierarchyKey].length <= 0) { // Has no children
            return false;
        }

        const dataKey = (null != this.props.dataKey) ? this.props.dataKey : "isExpanded";
        return (null == row[dataKey] || row[dataKey]);
    }

    getPrevRow(rows: any[], row: any, previousRow: any):any {
        const dataKey = (null != this.props.dataKey) ? this.props.dataKey : "isExpanded";

        for(let i = 0; i < rows.length; i++) {
            if(this.foundPrevRow) {
                return previousRow;
            } else if(row == null) {
                return rows[i];
            } else if(rows[i] == row) {
                this.foundPrevRow = true;
                return previousRow;
            }

            previousRow = rows[i];

            if(null != rows[i][dataKey] && rows[i][dataKey] && null != rows[i][this.props.hierarchyKey] && rows[i][this.props.hierarchyKey].length > 0) {
                previousRow = this.getPrevRow(rows[i][this.props.hierarchyKey], row, previousRow);
            }
        }
        return previousRow;
    }

    rowIsExpanded(row: any) {
        const dataKey = (null != this.props.dataKey) ? this.props.dataKey : "isExpanded";
        return null != row[dataKey] && row[dataKey];
    }

    rowHasChildren(row: any) {
        return null != this.props.hierarchyKey && null != row[this.props.hierarchyKey] && row[this.props.hierarchyKey].length > 0;
    }

    getPrevRowWithKey(rows: any[], rowKey: string, previousRow: any, bShift: boolean, bCtrl: boolean):any {
        const dataKey = (null != this.props.dataKey) ? this.props.dataKey : "isExpanded";

        for(let i = 0; i < rows.length; i++) {
            if(this.foundPrevRow) {
                return previousRow;
            } else if(rows[i][this.props.rowKey] == rowKey) {
                this.foundPrevRow = true;
                return previousRow;
            }

            if(this.props.allowFocusOnRow(rows[i], bShift, bCtrl, false, false)) {
                previousRow = rows[i];
            }

            const isExpanded = null != rows[i][dataKey] && rows[i][dataKey];
            const hasChildren = this.rowHasChildren(rows[i]);

            if(isExpanded && hasChildren) {
                previousRow = this.getPrevRowWithKey(rows[i][this.props.hierarchyKey], rowKey, previousRow, bShift, bCtrl);
            }
        }
        return previousRow;
    }

    getNextRowWithKey(rows: any[], selectedKey: string, bShift: boolean, bCtrl: boolean):any {
        const dataKey = (null != this.props.dataKey) ? this.props.dataKey : "isExpanded";
        for(let i = 0; i < rows.length; i++) {
            if(this.returnNextRow || (this.foundCurrentRow && this.props.allowFocusOnRow(rows[i], bShift, bCtrl, false, false))) {
                this.returnNextRow = true;
                return rows[i];
            } else if(rows[i][this.props.rowKey] == selectedKey) {
                this.foundCurrentRow = true;
            }

            const isExpanded = null != rows[i][dataKey] && rows[i][dataKey];
            const hasChildren = this.rowHasChildren(rows[i]);

            if(isExpanded && hasChildren) {
                const nextRow = this.getNextRowWithKey(rows[i][this.props.hierarchyKey], selectedKey, bShift, bCtrl);
                if(null != nextRow) {
                    return nextRow;
                }
            }
        }
        return null;
    }

    getNextRow(rows: any[], row: any, bShift: boolean, bCtrl: boolean):any {
        const dataKey = (null != this.props.dataKey) ? this.props.dataKey : "isExpanded";
        for(let i = 0; i < rows.length; i++) {
            if(null == row) {
                return rows[i];
            } else if(rows[i] == row) {
                this.foundCurrentRow = true;
            } else if(this.returnNextRow || (this.foundCurrentRow && this.props.allowFocusOnRow(rows[i], bShift, bCtrl, false, false))) {
                this.returnNextRow = true;
                return rows[i];
            }

            if(null != rows[i][dataKey] && rows[i][dataKey] && this.rowHasChildren(rows[i])) {
                const nextRow = this.getNextRow(rows[i][this.props.hierarchyKey], row, bShift, bCtrl);
                if(null != nextRow) {
                    return nextRow;
                }
            }
        }
        return null;
    }

    getScrollableRow(row: any, wheelUp: boolean): any {
        if(this.rowIsExpanded(row) && this.rowHasChildren(row)) {
            const pagingDataIndex = this.indexOfPagingData(row[this.props.rowKey], this.currentPagingData);
            if(pagingDataIndex > -1) {
                const startPos = this.currentPagingData[pagingDataIndex].startPos;
                if (wheelUp) {
                    if(startPos > 0) {
                        return row;
                    }
                } else {
                    const totalNumberOfChildren = (row[this.props.hierarchyKey] as any[]).length;
                    if (totalNumberOfChildren > (startPos + this.props.hierarchyNumToDisplay)) {
                        return row;
                    }
                }
            }
        }

        this.foundParentRow = false;
        const parentRow = this.getParentRow((this.state as ReactHierarchicalListState).rows, row, null);
        if(null != parentRow) {
            return this.getScrollableRow(parentRow, wheelUp);
        } else {
            return row;
        }
    }

    onRowScroll(row: any, wheelUp: boolean):boolean {
        let success = false;
        if(null != row && null != this.props.rowKey) {
            let rowToScroll = (this.props.scrollWithScrollBarAfterPaging) ? this.getScrollableRow(row, wheelUp) : row;

            const totalNumberOfChildren = (rowToScroll[this.props.hierarchyKey] as any[]).length;

            const pagingDataIndex = this.indexOfPagingData(rowToScroll[this.props.rowKey], this.currentPagingData);
            if(pagingDataIndex > -1) {
                let startPos = this.currentPagingData[pagingDataIndex].startPos;

                // Scroll up the number to display
                if(wheelUp) {
                    if(startPos > 0) {
                        startPos = startPos - this.props.hierarchyNumToDisplay;
                        if(startPos < 0) {
                            startPos = 0;
                        }
                    }
                } else {
                    // Scroll down the number to display
                    startPos = startPos + this.props.hierarchyNumToDisplay;
                }

                // If we are at the end, display the max number of rows
                if(totalNumberOfChildren <= (startPos + this.props.hierarchyNumToDisplay)) {
                    startPos = totalNumberOfChildren - this.props.hierarchyNumToDisplay;
                }

                success = this.updateManualPageIndex(startPos, rowToScroll[this.props.rowKey], true);
            }
        }
        return !this.props.scrollWithScrollBarAfterPaging || success;
    }

    onRightClick(rowToHighlight: any, shiftKey: boolean, ctrlKey: boolean, hierarchyIndex: number) {
        if(this.props.highlightOnClick) {

            let canHighlight = true;
            if(null != this.props.allowFocusOnRow) {
                canHighlight = this.props.allowFocusOnRow(rowToHighlight, shiftKey, ctrlKey, true, true);
            }
            if(canHighlight) {
                let localHighlightKey = "";
                let localSelectedHierarchyLevelData: HierarchyLevelData[] = [];
                if(null != this.props.rowKey && null != rowToHighlight) {
                    localHighlightKey = rowToHighlight[this.props.rowKey];
                    localSelectedHierarchyLevelData = this.getHierarchyLevelData(localHighlightKey, "-1", 0, (this.state as ReactHierarchicalListState).rows);
                }

                let maintainSelection = false;
                let selectInbetween = false;
                if(ctrlKey) {
                    maintainSelection = true;
                } else if(shiftKey) {
                    maintainSelection = true;
                    selectInbetween = true;
                }
                this.setState(() => {
                    if(this.props.enableMultiSelect) {
                        this.selectRow((this.state as ReactHierarchicalListState).rows, rowToHighlight, maintainSelection, selectInbetween, false);
                    } else {
                        this.selectRow((this.state as ReactHierarchicalListState).rows, rowToHighlight, false, false, false);
                    }
                    this.lastSelectedRow = rowToHighlight;

                    return {
                        rows: (this.state as ReactHierarchicalListState).rows,
                        highlightKey: localHighlightKey,
                        selectedHierarchyLevelData: localSelectedHierarchyLevelData,
                        highlightSelectedRow: this.getHighlightRow((this.state as ReactHierarchicalListState).rows, localHighlightKey),
                        rowIsClicked: true,
                    }
                }, () => {
                    if(null != this.props.onRowRightClick) {
                        this.foundParentRow = false;
                        const parentRow = this.getParentRow((this.state as ReactHierarchicalListState).rows, rowToHighlight, null);
                        let indexInParent = -1;
                        if(null != parentRow && null != parentRow[this.props.hierarchyKey] && parentRow[this.props.hierarchyKey].length > 0) {
                            indexInParent = parentRow[this.props.hierarchyKey].indexOf(rowToHighlight);
                        }

                        this.props.onRowRightClick(rowToHighlight, shiftKey, ctrlKey, hierarchyIndex, parentRow, indexInParent, this.getSelectedRows((this.state as ReactHierarchicalListState).rows));
                    }
                });
            }
        } else {
            if(null != this.props.onRowRightClick) {
                this.foundParentRow = false;
                const parentRow = this.getParentRow((this.state as ReactHierarchicalListState).rows, rowToHighlight, null);
                let indexInParent = -1;
                if(null != parentRow && null != parentRow[this.props.hierarchyKey] && parentRow[this.props.hierarchyKey].length > 0) {
                    indexInParent = parentRow[this.props.hierarchyKey].indexOf(rowToHighlight);
                }

                this.props.onRowRightClick(rowToHighlight, shiftKey, ctrlKey, hierarchyIndex, parentRow, indexInParent, this.getSelectedRows((this.state as ReactHierarchicalListState).rows));
            }
        }
    }

    onClick(rowToHighlight: any, shiftKey: boolean, ctrlKey: boolean, hierarchyIndex: number, isRowClick?: boolean) {
        if(this.props.highlightOnClick && (null != isRowClick && isRowClick)) {
            if(null != rowToHighlight) {

                let canHighlight = true;
                if(null != this.props.allowFocusOnRow) {
                    canHighlight = this.props.allowFocusOnRow(rowToHighlight, shiftKey, ctrlKey, true, false);
                }

                if(canHighlight) {
                    if(null != this.props.rowKey) {
                        let localHighlightKey = rowToHighlight[this.props.rowKey];
                        let localSelectedHierarchyLevelData = this.getHierarchyLevelData(localHighlightKey, "-1", 0, (this.state as ReactHierarchicalListState).rows);

                        let maintainSelection = false;
                        let selectInbetween = false;
                        if(ctrlKey) {
                            maintainSelection = true;
                        } else if(shiftKey) {
                            maintainSelection = true;
                            selectInbetween = true;
                        }
                        this.setState(() => {
                            if(this.props.enableMultiSelect) {
                                this.selectRow((this.state as ReactHierarchicalListState).rows, rowToHighlight, maintainSelection, selectInbetween, false);
                                this.lastSelectedRow = rowToHighlight;
                            }

                            return {
                                rows: (this.state as ReactHierarchicalListState).rows,
                                rowIsDragging: false,
                                highlightKey: localHighlightKey,
                                selectedHierarchyLevelData: localSelectedHierarchyLevelData,
                                highlightSelectedRow: this.getHighlightRow((this.state as ReactHierarchicalListState).rows, localHighlightKey),
                                rowIsClicked: true,
                            }
                        });
                    } else {
                        let maintainSelection2 = false;
                        let selectInbetween2 = false;
                        if(ctrlKey) {
                            maintainSelection2 = true;
                        } else if(shiftKey) {
                            maintainSelection2 = true;
                            selectInbetween2 = true;
                        }
                        this.setState(() => {
                            if(this.props.enableMultiSelect) {
                                this.selectRow((this.state as ReactHierarchicalListState).rows, rowToHighlight, maintainSelection2, selectInbetween2, false);
                                this.lastSelectedRow = rowToHighlight;
                            } else {
                                this.selectRow((this.state as ReactHierarchicalListState).rows, rowToHighlight, false, false, false);
                            }
                            this.lastSelectedRow = rowToHighlight;

                            return {
                                rows: (this.state as ReactHierarchicalListState).rows,
                                highlightSelectedRow: rowToHighlight,
                                rowIsDragging: false,
                            }
                        });
                    }
                }
            }

            return false;
        } else {
            if(null != this.props.onRowClick) {
                this.foundParentRow = false;
                const parentRow = this.getParentRow((this.state as ReactHierarchicalListState).rows, rowToHighlight, null);
                let indexInParent = -1;
                if(null != parentRow && null != parentRow[this.props.hierarchyKey] && parentRow[this.props.hierarchyKey].length > 0) {
                    indexInParent = parentRow[this.props.hierarchyKey].indexOf(rowToHighlight);
                }
                return this.props.onRowClick(rowToHighlight, shiftKey, ctrlKey, hierarchyIndex, parentRow, indexInParent, this.getSelectedRows((this.state as ReactHierarchicalListState).rows));
            } else {
                const dataKey = (null != this.props.dataKey) ? this.props.dataKey : "isExpanded";
                const isExpanded = null != rowToHighlight[dataKey] && rowToHighlight[dataKey];
                return !isExpanded;
            }
        }
    }

    onDelete(row: any, shiftKey: boolean, ctrlKey: boolean, hierarchyIndex: number) {
        this.foundParentRow = false;
        const parentRow = this.getParentRow((this.state as ReactHierarchicalListState).rows, row, null);
        let indexInParent = -1;
        if(null != parentRow && null != parentRow[this.props.hierarchyKey] && parentRow[this.props.hierarchyKey].length > 0) {
            indexInParent = parentRow[this.props.hierarchyKey].indexOf(row);
        }

        let deleteRowAndAllChildren = true;
        if(null != this.props.onRowDelete) {
            deleteRowAndAllChildren = this.props.onRowDelete(row, shiftKey, ctrlKey, hierarchyIndex, parentRow, indexInParent);
        }

        if(deleteRowAndAllChildren) {
            if(this.foundParentRow) {
                if(indexInParent > -1) {
                    parentRow[this.props.hierarchyKey].splice(indexInParent, 1);
                } else {
                    const indexInRow = (this.state as ReactHierarchicalListState).rows.indexOf(row);
                    if(indexInRow > -1) {
                        (this.state as ReactHierarchicalListState).rows.splice(indexInRow, 1);
                    }
                }
                this.setState(() => {
                        return {
                            rows: (this.state as ReactHierarchicalListState).rows,
                            rowIsDragging: false,
                            highlightIndex: -1,
                            selectedHierarchyLevelData: [],
                        }
                    },
                    () => {
                        if (null != this.props.onAfterRowDelete) {
                            this.props.onAfterRowDelete();
                        }
                    });
            }
        }
    }

    onDragHandler(event: any, dragOverRow: any) {
        if(this.props.enableDragAndDrop && null != (this.state as ReactHierarchicalListState).highlightSelectedRow && null != (this.state as ReactHierarchicalListState).highlightSelectedRow.allowDrag && (this.state as ReactHierarchicalListState).highlightSelectedRow.allowDrag && null != dragOverRow) {
            this.foundParentRow = false;
            const currentParentRow = this.getParentRow((this.state as ReactHierarchicalListState).rows, (this.state as ReactHierarchicalListState).highlightSelectedRow, null);

            const isHiddenDragRow = null != dragOverRow.isHiddenDragRow && dragOverRow.isHiddenDragRow;

            let allowDrag = false;
            let allowDrop = false;
            if(this.props.enableUnboundDragAndDrop && isHiddenDragRow) {
                if(null != dragOverRow.isBottomRow) { // If there is not parent then this is the bottom of the Hierarchy
                    allowDrop = this.props.allowDropToTheBottom;
                } else {
                    allowDrop = (null != dragOverRow.hiddenParentRow && null != dragOverRow.hiddenParentRow.allowDrop && dragOverRow.hiddenParentRow.allowDrop) && !this.isRelatedTo((this.state as ReactHierarchicalListState).highlightSelectedRow, dragOverRow.hiddenParentRow);
                }

                if(allowDrop) {
                    // Dragging over a hidden drag row
                    let currentIndex = -1;
                    if (null != currentParentRow) {
                        currentIndex = currentParentRow[this.props.hierarchyKey].indexOf((this.state as ReactHierarchicalListState).highlightSelectedRow);
                        if(currentIndex > -1) {
                            currentParentRow[this.props.hierarchyKey].splice(currentIndex, 1);
                        }
                    } else {
                        currentIndex = (this.state as ReactHierarchicalListState).rows.indexOf((this.state as ReactHierarchicalListState).highlightSelectedRow)
                        if(currentIndex > -1) {
                            (this.state as ReactHierarchicalListState).rows.splice(currentIndex, 1);
                        }
                    }

                    if(currentIndex > -1) {
                        if(null != dragOverRow.hiddenParentRow) {
                            // Drag as a child of the parent row
                            dragOverRow.hiddenParentRow[this.props.hierarchyKey].push((this.state as ReactHierarchicalListState).highlightSelectedRow);
                        } else {
                            // If the parent is null then add to the end of the base (parent most) list
                            (this.state as ReactHierarchicalListState).rows.push((this.state as ReactHierarchicalListState).highlightSelectedRow);
                        }
                    }
                }
            } else {
                let dragParentRow = null;
                // Check if the dragOverRow is a child of the parent element, Dont allow the parent object to be dragged into its own child
                if(this.isRelatedTo((this.state as ReactHierarchicalListState).highlightSelectedRow, dragOverRow)) {
                    dragParentRow = currentParentRow; // Prevent the parent from being dragged into its own child
                } else {
                    this.foundParentRow = false;
                    dragParentRow = this.getParentRow((this.state as ReactHierarchicalListState).rows, dragOverRow, null);
                }

                allowDrag = (currentParentRow == dragParentRow) && (null != dragOverRow.allowDrag && dragOverRow.allowDrag);

                if(null != dragParentRow) {
                    allowDrop = (null != dragParentRow.allowDrop && dragParentRow.allowDrop);
                } else {
                    allowDrop = (null != dragOverRow.allowDrop && dragOverRow.allowDrop);
                }

                if(allowDrop || allowDrag) {
                    // Check if we are dragging items on the same level
                    if(allowDrag) {
                        if (null != currentParentRow) {
                            const currentIndex = dragParentRow[this.props.hierarchyKey].indexOf((this.state as ReactHierarchicalListState).highlightSelectedRow);
                            const dragIndex = dragParentRow[this.props.hierarchyKey].indexOf(dragOverRow);
                            if (currentIndex > -1 && dragIndex > -1) {
                                dragParentRow[this.props.hierarchyKey].splice(currentIndex, 1);
                                dragParentRow[this.props.hierarchyKey].splice(dragIndex, 0, (this.state as ReactHierarchicalListState).highlightSelectedRow);
                            }
                        } else {
                            const currentIndex = (this.state as ReactHierarchicalListState).rows.indexOf((this.state as ReactHierarchicalListState).highlightSelectedRow)
                            const dragIndex = (this.state as ReactHierarchicalListState).rows.indexOf(dragOverRow)
                            if(currentIndex > -1 && dragIndex > -1) {
                                (this.state as ReactHierarchicalListState).rows.splice(currentIndex, 1);
                                (this.state as ReactHierarchicalListState).rows.splice(dragIndex, 0, (this.state as ReactHierarchicalListState).highlightSelectedRow);
                            }
                        }
                    } else if(this.props.enableUnboundDragAndDrop) { // Drag items to new levels
                        let currentIndex = -1;
                        if (null != currentParentRow) {
                            currentIndex = currentParentRow[this.props.hierarchyKey].indexOf((this.state as ReactHierarchicalListState).highlightSelectedRow);
                        } else {
                            currentIndex = (this.state as ReactHierarchicalListState).rows.indexOf((this.state as ReactHierarchicalListState).highlightSelectedRow)
                        }

                        let dragIndex = -1;
                        if (null != dragParentRow) {
                            dragIndex = dragParentRow[this.props.hierarchyKey].indexOf(dragOverRow);
                        } else {
                            dragIndex = (this.state as ReactHierarchicalListState).rows.indexOf(dragOverRow)
                        }

                        if (currentIndex > -1 && dragIndex > -1) {
                            if (null != currentParentRow) {
                                currentParentRow[this.props.hierarchyKey].splice(currentIndex, 1);
                            } else {
                                (this.state as ReactHierarchicalListState).rows.splice(currentIndex, 1);
                            }

                            if (null != dragParentRow) {
                                dragParentRow[this.props.hierarchyKey].splice(dragIndex, 0, (this.state as ReactHierarchicalListState).highlightSelectedRow);
                            } else {
                                (this.state as ReactHierarchicalListState).rows.splice(dragIndex, 0, (this.state as ReactHierarchicalListState).highlightSelectedRow);
                            }
                        }
                    }
                }
            }

            if(allowDrop || allowDrag) {
                this.setState(() => {
                    return {
                        rows: (this.state as ReactHierarchicalListState).rows,
                    }
                }, () => {
                    this.executeScroll();
                });
            }
        } else if(this.props.enableMultiSelect && this.props.selectRecordsWithRowDrag) {
            if(null != dragOverRow) {
                if(!event.shiftKey && !event.ctrlKey) {
                    this.clearSelection((this.state as ReactHierarchicalListState).rows);
                }
                this.setState(() => {
                    this.selectRowOnDrag((this.state as ReactHierarchicalListState).rows, dragOverRow, false);
                    return {
                        rows: (this.state as ReactHierarchicalListState).rows,
                    }
                }, () => {
                    if(this.props.highlightOnClick) {
                        this.executeScroll();
                    }
                });
            }
        }
    }

    // Function to run when row is dropped
    onDrop(event: any) {
        // Call the onDropEvent function if it exists
        if(null != this.props.onDropEvent) {
            this.props.onDropEvent(event);
        }

        this.setState({
            rows: (this.state as ReactHierarchicalListState).rows,
            rowIsDragging: false
        });
    }

    onDragStartHandler(event: any, dragRow: any) {
        const isHiddenDragRow = null != dragRow.isHiddenDragRow && dragRow.isHiddenDragRow;
        if(!isHiddenDragRow && this.props.enableDragAndDrop && !(this.state as ReactHierarchicalListState).disabled) {
            if(null != dragRow.allowDrag && dragRow.allowDrag) {
                this.setState(() => {

                    this.selectRow((this.state as ReactHierarchicalListState).rows, dragRow, false, false, false);
                    this.lastSelectedRow = dragRow;

                    return {
                        rows: (this.state as ReactHierarchicalListState).rows,
                        highlightSelectedRow: dragRow,
                        rowIsDragging: true,
                    }
                }, () => {
                    if(this.props.highlightOnClick) {
                        this.executeScroll();
                    }
                });
            }
        } else if(this.props.enableMultiSelect && this.props.selectRecordsWithRowDrag) {
            if(!event.shiftKey && !event.ctrlKey) {
                this.clearSelection((this.state as ReactHierarchicalListState).rows);
            }

            this.setState(() => {
                this.lastSelectedRow = dragRow;
                this.selectRowOnDrag((this.state as ReactHierarchicalListState).rows, dragRow, false);
                return {
                    rows: (this.state as ReactHierarchicalListState).rows,
                    highlightSelectedRow: dragRow,
                    rowIsDragging: false,
                }
            }, () => {
                if(this.props.highlightOnClick) {
                    this.executeScroll();
                }
            });
        }
    }

    getHierarchyIndex(row: any):number {
        for(let i = 0; i < this.totalRows.length; i++) {
            if(this.totalRows[i] == row) {
                return i;
            }
        }
        return -1;
    }

    // Handle On Key Down Events
    onKeyDown(event: any) {
        const keyUp = event.key == "ArrowUp";
        const keyDown = event.key == "ArrowDown";
        const keyLeft = event.key == "ArrowLeft";
        const keyRight = event.key == "ArrowRight";
        const keyTab = event.key == "Tab";
        const keyEnter = event.key == "Enter";

        let keyPressed = false;
        if  (this.props.highlightOnClick && (keyUp || keyDown)) {
            // Move the Highlight Selected Row up and down
            keyPressed = true;

            this.foundCurrentRow = false;
            let nextRow: any = null;

            if(null != this.props.rowKey) {
                const selectedRowKey =  (this.state as ReactHierarchicalListState).highlightKey;
                if(keyUp) {
                    this.foundPrevRow = false;
                    nextRow = this.getPrevRowWithKey((this.state as ReactHierarchicalListState).rows, selectedRowKey, null, event.shiftKey, event.ctrlKey);
                } else {
                    this.returnNextRow = false;
                    nextRow = this.getNextRowWithKey((this.state as ReactHierarchicalListState).rows, selectedRowKey, event.shiftKey, event.ctrlKey);
                }
            } else {
                if(keyUp) {
                    this.foundPrevRow = false;
                    nextRow = this.getPrevRow((this.state as ReactHierarchicalListState).rows, (this.state as ReactHierarchicalListState).highlightSelectedRow, null);
                } else {
                    this.returnNextRow = false;
                    nextRow = this.getNextRow((this.state as ReactHierarchicalListState).rows, (this.state as ReactHierarchicalListState).highlightSelectedRow, event.shiftKey, event.ctrlKey);
                }
            }

            if(null != nextRow) {
                if(null != this.props.rowKey) {
                    let localHighlightKey = nextRow[this.props.rowKey];
                    let localSelectedHierarchyLevelData = this.getHierarchyLevelData(localHighlightKey, "-1", 0, (this.state as ReactHierarchicalListState).rows);
                    let scrollToSelection = true;

                    // This is a key press on the keyboard, lets scroll the newly selected element into view
                    for(const elem of localSelectedHierarchyLevelData) {
                        const pagingIndex = this.indexOfPagingData(elem.rowKey, this.currentPagingData);
                        if(pagingIndex > -1) {
                            scrollToSelection = this.updateManualPageIndex(-1, elem.rowKey, false); // If the page is not updated then we should keep the current scroll position
                        }
                    }

                    let maintainSelection = false;
                    let selectInbetween = false;
                    if(event.ctrlKey) {
                        maintainSelection = true;
                    } else if(event.shiftKey) {
                        maintainSelection = true;
                        selectInbetween = true;
                    }

                    this.setState(() => {
                        if(this.props.enableMultiSelect) {
                            this.selectRow((this.state as ReactHierarchicalListState).rows, nextRow, maintainSelection, selectInbetween, false);
                            this.lastSelectedRow = nextRow;
                        }

                        return {
                            rows: (this.state as ReactHierarchicalListState).rows,
                            rowIsDragging: false,
                            highlightKey: localHighlightKey,
                            selectedHierarchyLevelData: localSelectedHierarchyLevelData,
                            highlightSelectedRow: this.getHighlightRow((this.state as ReactHierarchicalListState).rows, localHighlightKey),
                            rowIsClicked: false,
                        }
                    }, () => {
                        const isInView = this.isElementInViewport(this.highlightRowRef.current);
                        if(this.props.highlightOnClick && (!isInView || scrollToSelection)) {
                            this.executeScroll();
                        }
                    });
                } else {
                    let maintainSelection2 = false;
                    let selectInbetween2 = false;
                    if(event.ctrlKey) {
                        maintainSelection2 = true;
                    } else if(event.shiftKey) {
                        maintainSelection2 = true;
                        selectInbetween2 = true;
                    }

                    this.setState(() => {
                        if(this.props.enableMultiSelect) {
                            this.selectRow((this.state as ReactHierarchicalListState).rows, nextRow, maintainSelection2, selectInbetween2, false);
                        } else {
                            this.selectRow((this.state as ReactHierarchicalListState).rows, nextRow, false, false, false);
                        }
                        this.lastSelectedRow = nextRow;

                        return {
                            rows: (this.state as ReactHierarchicalListState).rows,
                            highlightSelectedRow: nextRow,
                            rowIsDragging: false,
                        }
                    }, () => {
                        if(this.props.highlightOnClick) {
                            this.executeScroll();
                        }
                    });
                }
            } else {
                if(null != this.props.onFocusEndKeyPressEvent) {
                    this.props.onFocusEndKeyPressEvent(null, event.key, event.shiftKey, event.ctrlKey);
                }
            }
        } else if (this.props.highlightOnClick && (keyLeft || keyRight)) {
            const hierarchyIndex = this.getHierarchyIndex((this.state as ReactHierarchicalListState).highlightSelectedRow);
            if(this.getAllowExpandAndCollapse((this.state as ReactHierarchicalListState).highlightSelectedRow, hierarchyIndex, event.shiftKey, event.ctrlKey)) {

                // Expand / Collapse highlighted row
                const dataKey = (null != this.props.dataKey) ? this.props.dataKey : "isExpanded";
                if(keyLeft) {
                    if(this.rowCanCollapse((this.state as ReactHierarchicalListState).highlightSelectedRow)) {
                        this.setState(() => {
                            (this.state as ReactHierarchicalListState).highlightSelectedRow[dataKey] = false;

                            return {
                                rows: (this.state as ReactHierarchicalListState).rows,
                                highlightSelectedRow: (this.state as ReactHierarchicalListState).highlightSelectedRow,
                                rowIsDragging: false,
                                rowIsClicked: false,
                            }
                        }, () => {
                            if(this.props.highlightOnClick) {
                                this.executeScroll();
                            }
                        });
                        } else {
                            if(null != this.props.onFocusEndKeyPressEvent) {
                                this.props.onFocusEndKeyPressEvent((this.state as ReactHierarchicalListState).highlightSelectedRow, event.key, event.shiftKey, event.ctrlKey);
                            }
                    }
                } else {
                    if(this.rowCanExpand((this.state as ReactHierarchicalListState).highlightSelectedRow)) {
                        this.setState(() => {
                            (this.state as ReactHierarchicalListState).highlightSelectedRow[dataKey] = true;

                            return {
                                rows: (this.state as ReactHierarchicalListState).rows,
                                highlightSelectedRow: (this.state as ReactHierarchicalListState).highlightSelectedRow,
                                rowIsDragging: false,
                                rowIsClicked: false,
                            }
                        }, () => {
                            if(this.props.highlightOnClick) {
                                this.executeScroll();
                            }
                        });
                        } else {
                            if(null != this.props.onFocusEndKeyPressEvent) {
                                this.props.onFocusEndKeyPressEvent((this.state as ReactHierarchicalListState).highlightSelectedRow, event.key, event.shiftKey, event.ctrlKey);
                            }
                    }
                }
            }

            // This is a key press on the keyboard, lets scroll the currently highlighted element into view
            let localHighlightKey = (this.state as ReactHierarchicalListState).highlightSelectedRow[this.props.rowKey];
            let localSelectedHierarchyLevelData = this.getHierarchyLevelData(localHighlightKey, "-1", 0, (this.state as ReactHierarchicalListState).rows);
            let scrollToSelection = true;
            for(const elem of localSelectedHierarchyLevelData) {
                const pagingIndex = this.indexOfPagingData(elem.rowKey, this.currentPagingData);
                if(pagingIndex > -1) {
                    scrollToSelection = this.updateManualPageIndex(-1, elem.rowKey, false);
                }
            }
        } else if(this.props.highlightOnClick) {
            // Execute Enter Command
            if(this.props.highlightOnClick) {
                this.executeScroll();
            }
        }

        if (null != this.props.onKeyDown) {
            this.props.onKeyDown((this.state as ReactHierarchicalListState).highlightSelectedRow, event.key, this.getHierarchyIndex((this.state as ReactHierarchicalListState).highlightSelectedRow), event.shiftKey, event.ctrlKey, event.altKey, this.getSelectedRows((this.state as ReactHierarchicalListState).rows));
        }

        if (keyPressed) {
            event.preventDefault();
        }

        if (null != this.props.stopPropagationOnKeyPress) {
            const hierarchyIndex = this.getHierarchyIndex((this.state as ReactHierarchicalListState).highlightSelectedRow);
            const selectRow = (this.state as ReactHierarchicalListState).highlightSelectedRow;
            if(this.props.stopPropagationOnKeyPress(selectRow, hierarchyIndex, event.key, false, event.shiftKey, event.ctrlKey, event.altKey)) {
                event.stopPropagation();
            }
        }
    }

    onKeyUp(event: any) {
        if (null != this.props.onKeyUp) {
            this.props.onKeyUp((this.state as ReactHierarchicalListState).highlightSelectedRow, event.key, this.getHierarchyIndex((this.state as ReactHierarchicalListState).highlightSelectedRow), event.shiftKey, event.ctrlKey, event.altKey);
        }
        if (null != this.props.stopPropagationOnKeyPress) {
            const hierarchyIndex = this.getHierarchyIndex((this.state as ReactHierarchicalListState).highlightSelectedRow);
            const selectRow = (this.state as ReactHierarchicalListState).highlightSelectedRow;
            if (this.props.stopPropagationOnKeyPress(selectRow, hierarchyIndex, event.key, true, event.shiftKey, event.ctrlKey, event.altKey)) {
                event.stopPropagation();
            }
        }
    }

    onRefresh() {
        if(null != this.props.onRefresh) {
            this.props.onRefresh();
        }
        this.totalRows = [];
        this.foundPrevRow = false;
        this.returnNextRow = false;
        this.foundParentRow = false;
        this.foundCurrentRow = false;

        this.setState(() => ({
            rows: (this.state as ReactHierarchicalListState).rows,
            rowCount: -1
        }));
    }

    getScrollParent (el: HTMLElement) {
        if (!el) {return null;}

        let parent = el.parentElement;
        while (parent) {
            if(parent.classList.contains("overFlowAuto")) {
                return parent;
            }

            parent = parent.parentElement;
        }

        return null;
    }

    isElementInViewport (el: HTMLElement) {
        if (!el) {return null;}

        const container = this.getScrollParent(el);
        if(null != container) {
            const rect = el.getBoundingClientRect();
            const containerRect = container.getBoundingClientRect();
            return (
                rect.top >= containerRect.top &&
                rect.left >= containerRect.left &&
                rect.bottom <= containerRect.bottom &&
                rect.right <= containerRect.right
            );
        }
        return null;
    }

    getLastHighlightKey(localHighlightKey: string[]) {
        if(localHighlightKey.length > 0) {
            return localHighlightKey[localHighlightKey.length - 1];
        }
        return '';
    }

    indexOfHighlightKey(rowKeys: string[], key: string) {
        if(null != rowKeys) {
            for (let i = 0; i < rowKeys.length; i++) {
                if(rowKeys[i] == key) {
                    return i;
                }
            }
        }

        return -1;
    }

    executeScroll() {
        if(null != this.props.overrideScrollIntoView) {
            this.props.overrideScrollIntoView(this.highlightRowRef.current, (this.state as ReactHierarchicalListState).highlightKey);
        } else {
            // Scroll the highlighted selected row into view
            if(null != this.highlightRowRef.current && null != (this.state as ReactHierarchicalListState).highlightKey && this.props.highlightOnClick) {
                this.highlightRowRef.current.scrollIntoView({block: "center", inline: "center"});
            }
        }
    }

    isRelatedTo(row: any, childRow: any):any {
        if(null == childRow) {
            return false;
        } else if(row == childRow) {
            return true;
        } else if(null != row[this.props.hierarchyKey] && row[this.props.hierarchyKey].length > 0) {
            for (let i = 0; i < row[this.props.hierarchyKey].length; i++) {
                if(this.isRelatedTo(row[this.props.hierarchyKey][i], childRow)) {
                    return true;
                }
            }
        }

        return false;
    }

    getRowDisplay(row: any, hierarchyIndex: number, isHiddenDragRow: boolean, levelCount: number, doHighlight: boolean) {
        if(isHiddenDragRow) {
            return <ReactHierarchicalRow
                id={(this.props.rowID.length > 0) ? this.props.rowID : this.props.id + '_row_' + hierarchyIndex}
                row={row}
                doHighlightRow={false}
                hierarchyIndex={hierarchyIndex}
                deleteButtonID={this.props.deleteButtonID}
            />;
        } else {
            row.hierarchyIndex = hierarchyIndex;

            let rowClass = "";
            if(null != row.css && 'undefined' != row.css) {
                rowClass = row.css;
            } else if(null != this.props.rowsCSS) {
                rowClass = this.props.rowsCSS(row, hierarchyIndex);
            }

            let rowStyle = {};
            if(null != row.style && 'undefined' != row.style) {
                rowStyle = row.style;
            } else if(null != this.props.rowsStyle) {
                rowStyle = this.props.rowsStyle(row, hierarchyIndex);
            }

            return <ReactHierarchicalRow
                id={(null != row.id) ? row.id : ((this.props.rowID.length > 0) ? this.props.rowID + '_' + hierarchyIndex: this.props.id + '_row_' + hierarchyIndex)}
                doHighlightRow={doHighlight}
                hightlightSelectedRowCSS={this.props.hightlightSelectedRowCSS}
                rowAdditionalAttributes={this.props.rowAdditionalAttributes}
                row={row}
                css={rowClass}
                style={rowStyle}
                hierarchyIndex={hierarchyIndex}
                displayValue={row[this.props.displayKey]}
                displayOverride={this.props.displayOverride}
                onRowClick={this.onClick}
                onRowRightClick={this.onRightClick}
                stopPropagationOnClick={this.props.stopPropagationOnClick}
                rowReference={((doHighlight) ? this.highlightRowRef : null)}
                onDelete={this.onDelete}
                disabled={(this.state as ReactHierarchicalListState).disabled}
                addDeleteButton={this.props.addDeleteButton}
                addSortIcon={this.props.addSortIcon && ((null != row.allowDrag) ? row.allowDrag : false)}
                addDropIcon={this.props.addDropIcon && ((null != row.allowDrop) ? row.allowDrop : false)}
                deleteButtonTabIndex={this.props.deleteButtonTabIndex}
                deleteButtonID={this.props.deleteButtonID}
                shouldRowUpdate={this.props.shouldRowUpdate}
                levelCount={levelCount}
            />;
        }
    }

    getRowContent(row: any, hierarchyIndex: number, countData: CountData, selectedHierarchyLevelData: HierarchyLevelData[], levelCount: number):any {
        if(null != this.props.contentOverride) {
            return this.props.contentOverride(row, hierarchyIndex, (this.state as ReactHierarchicalListState).disabled);
        } else if (null != this.props.hierarchyKey && null != row[this.props.hierarchyKey] && (row[this.props.hierarchyKey] as any[]).length > 0) {
            if(null != this.props.rowKey && this.props.hierarchyNumToDisplay > -1) {
                const totalNumberOfChildren = (row[this.props.hierarchyKey] as any[]).length;
                const halfWayPoint = Math.floor((this.props.hierarchyNumToDisplay / 2));

                let startPos = 0;

                if((this.state as ReactHierarchicalListState).rowIsClicked) {
                    const pagingDataIndex = this.indexOfPagingData(row[this.props.rowKey], this.currentPagingData);
                    if(pagingDataIndex > -1) {
                        startPos = this.currentPagingData[pagingDataIndex].startPos;
                    }
                } else {
                    let useManualStartingPosition = false;
                    const pagingDataIndex = this.indexOfPagingData(row[this.props.rowKey], (this.state as ReactHierarchicalListState).updatedPagingData);
                    if(pagingDataIndex > -1) {
                        if((this.state as ReactHierarchicalListState).updatedPagingData[pagingDataIndex].startPos > -1) {
                            startPos = (this.state as ReactHierarchicalListState).updatedPagingData[pagingDataIndex].startPos;
                            useManualStartingPosition = true;

                            if(totalNumberOfChildren <= (startPos + this.props.hierarchyNumToDisplay)) {
                                startPos = totalNumberOfChildren - this.props.hierarchyNumToDisplay;
                            }
                        }
                    }

                    if(!useManualStartingPosition) {
                        if(totalNumberOfChildren > this.props.hierarchyNumToDisplay) {
                            const hierarchyLevelIndex = this.parentIndexInHierarchyLevelData(row, selectedHierarchyLevelData);
                            if(hierarchyLevelIndex > -1) {
                                const parentHighlightIndex = selectedHierarchyLevelData[hierarchyLevelIndex].index;

                                if(totalNumberOfChildren <= (parentHighlightIndex + halfWayPoint)) {
                                    startPos = totalNumberOfChildren - this.props.hierarchyNumToDisplay;
                                } else {
                                    if(parentHighlightIndex > halfWayPoint) {
                                        startPos = Math.floor(parentHighlightIndex - halfWayPoint);
                                    }
                                }
                            }
                        }
                    }
                }

                const endPos = startPos + this.props.hierarchyNumToDisplay;

                let pageUpStartingIndex = startPos - this.props.hierarchyNumToDisplay;
                if(pageUpStartingIndex < 0) {
                    pageUpStartingIndex = 0;
                }
                this.updateCurrentPageIndex(startPos, row[this.props.rowKey]);

                const childListToDisplay = (row[this.props.hierarchyKey] as any[]).slice(startPos, endPos);
                return <React.Fragment>
                    {childListToDisplay.map((subRow, subIndex) => {
                        return <React.Fragment>
                            {(subIndex == 0 && startPos > 0) ? this.getAccordionPagingRow(row, hierarchyIndex, startPos, pageUpStartingIndex, false, levelCount) : null}
                            {this.getAccordionRow(subRow, false, countData, selectedHierarchyLevelData, levelCount)}
                            {(subIndex == (childListToDisplay.length - 1) && (endPos < totalNumberOfChildren)) ? this.getAccordionPagingRow(row, hierarchyIndex, startPos, endPos, true, levelCount) : null}
                        </React.Fragment>;
                    })}
                </React.Fragment>;
            } else {
                return (row[this.props.hierarchyKey] as any[]).map((subRow, subIndex) => {
                    return this.getAccordionRow(subRow, false, countData, selectedHierarchyLevelData, levelCount);
                })
            }
        } else if(this.props.enableUnboundDragAndDrop) {
            return this.getAccordionRow({isHiddenDragRow: true, hiddenParentRow: row}, true, countData, selectedHierarchyLevelData, levelCount);
        } else {
            return "";
        }
    }

    getPagingArrow(row: any, hierarchyIndex: number, pageDown: boolean, levelCount: number) {
        if(null != this.props.hierarchyPagingArrowDisplayOverride) {
            return this.props.hierarchyPagingArrowDisplayOverride(row, hierarchyIndex, pageDown, this.props.disabled, levelCount);
        } else {
            return <i
                style={{marginTop: '0px', paddingLeft: '16px'}}
                className={(pageDown) ? 'fas fa-arrow-down' : 'fas fa-arrow-up'}
            ></i>;
        }
    }

    getAccordionPagingRow(row: any, hierarchyIndex: number, startPos: number, nextPos: number, pageDown: boolean, levelCount: number) {
        const linkIDPrefix = (pageDown) ? '_pageDown' : '_pageUp';
        return <div
            className={"clickable"}
            id={this.props.id + '_' + hierarchyIndex + linkIDPrefix}
            onClick={() => this.updateManualPageIndex(nextPos, row[this.props.rowKey], true)}
        >
            {this.getPagingArrow(row, hierarchyIndex, pageDown, levelCount)}
        </div>;
    }

    getAccordionRow(row: any, isHiddenDragRow: boolean, countData: CountData, selectedHierarchyLevelData: HierarchyLevelData[], levelCount: number) {
        const isBottomRow = (null != row.isBottomRow && row.isBottomRow);

        if(!isHiddenDragRow) {
            this.totalRows.push(row);
        }
        const hierarchyIndex = this.totalRows.length - 1;

        const newID = (isBottomRow) ? this.props.id + '_hiddenBottomRow' : this.props.id + '_' + hierarchyIndex;

        let newExpandedID = "";
        if(isBottomRow) {
            newExpandedID = this.props.expandedID + '_hiddenBottomRow';
        } else if(null != this.props.rowKey && null != row[this.props.rowKey]) {
            newExpandedID = this.props.expandedID + '_' + row[this.props.rowKey];
        } else {
            newExpandedID = this.props.expandedID + '_' + hierarchyIndex;
        }

        if(this.props.enableDragAndDrop) {
            if(null != this.props.allowDrag) {
                this.foundParentRow = false;
                if(isHiddenDragRow) {
                    row.allowDrag = this.props.allowDrag(null, row.hiddenParentRow);
                } else {
                    this.foundParentRow = false;
                    const parentRow = this.getParentRow((this.state as ReactHierarchicalListState).rows, row, null);
                    row.allowDrag = this.props.allowDrag(row, parentRow);
                }
            } else if(null != row && null == row.allowDrag) {
                row.allowDrag = true;
            }

            if(null != this.props.allowDrop) {
                this.foundParentRow = false;
                if(isHiddenDragRow) {
                    row.allowDrop = this.props.allowDrop(null, row.hiddenParentRow);
                } else {
                    this.foundParentRow = false;
                    const parentRow = this.getParentRow((this.state as ReactHierarchicalListState).rows, row, null);
                    row.allowDrop = this.props.allowDrop(row, parentRow);
                }
            } else if(null != row && null == row.allowDrop) {
                row.allowDrop = true;
            }
        }

        if(null != this.props.allowExpandAndCollapse) {
            row.allowExpandAndCollapse = this.props.allowExpandAndCollapse(row, hierarchyIndex);

        } else if(null != row) {
            row.allowExpandAndCollapse = true;
        }

        let rowCSS = '';
        if(isBottomRow) {
            rowCSS = 'categoryAllHide';
        } else if((this.state as ReactHierarchicalListState).rowIsDragging && (this.state as ReactHierarchicalListState).highlightSelectedRow == row) {
            rowCSS = 'react-drag';
        }

        let doHighlight = false;
        if(this.props.highlightOnClick && !isHiddenDragRow) {
            if(null != this.props.rowKey) {
                doHighlight = (this.state as ReactHierarchicalListState).highlightKey == row[this.props.rowKey];
            } else {
                doHighlight = null != this.props.isSelectedKey && row[this.props.isSelectedKey];
            }
        }

        const setProps = {
            id: newID,
            shellID: hierarchyIndex + '',
            text: this.getRowDisplay(row, hierarchyIndex, isHiddenDragRow, levelCount, doHighlight),
            content: (isHiddenDragRow || isBottomRow) ? "" : this.getRowContent(row, hierarchyIndex, countData, selectedHierarchyLevelData, levelCount + 1),
            collapsedStyle: this.props.collapsedStyle,
            collapsedCSS: this.props.collapsedCSS,
            css: rowCSS,
            expandedCSS: this.props.expandedCSS,
            expandedStyle: this.props.expandedStyle,
            contentStyle: (null != this.props.contentStyle) ? this.props.contentStyle(row, hierarchyIndex) : {marginTop: '0px', paddingLeft: '16px', fontWeight: "normal"},
            contentCSS: (isBottomRow) ? 'categoryAllHide' : this.props.contentCSS,
            dataKey: this.props.dataKey,
            row: row,
            rowIndex: hierarchyIndex,
            onClick: this.onClick,
            onRefresh: this.props.onRefresh,
            expandedID: newExpandedID,
            stopPropagationOnClick: this.props.stopPropagationOnClick,
            disableID: this.props.disableID + '_' + hierarchyIndex,
            disabled: (this.state as ReactHierarchicalListState).disabled,
            arrowExpandCSS: this.props.arrowExpandCSS,
            arrowCollapseCSS: this.props.arrowCollapseCSS,
            arrowStyle: (null != this.props.arrowStyle) ? this.props.arrowStyle(row, hierarchyIndex) : {width: "16px", marginTop: "1px"},
            enableDragAndDrop: ((null != row.allowDrag) ? row.allowDrag : false) || ((null != row.allowDrop) ? row.allowDrop : false),
            onDragStart: this.onDragStartHandler,
            onDragStop: this.onDrop,
            onDuringDrag: this.onDragHandler,
            allowExpandAndCollapse: (null != row.allowExpandAndCollapse) ? row.allowExpandAndCollapse : true,
            onWheel: (this.onRowScroll),
            leftOfArrowContent: (isBottomRow) ? null : this.props.leftOfArrowContent,
            doHighlight: doHighlight,
            onCollapseExpandAccordion: this.props.onCollapseExpandAccordion,
            selectRecordsWithRowDrag: ((null != this.props.selectRecordsWithRowDrag) ? this.props.selectRecordsWithRowDrag : false),
        };
        return getReactAccordion(setProps);
    }

    getAllowExpandAndCollapse(row: any, hierarchyIndex: number, shiftKey: boolean, ctrlKey: boolean ) {
        let allowExpandAndCollapse = true;
        if(null != row) {
            if(null != row.allowExpandAndCollapse && undefined != row.allowExpandAndCollapse) {
                allowExpandAndCollapse = row.allowExpandAndCollapse;
            }

            if(null != this.props.onCollapseExpandAccordion) {
                allowExpandAndCollapse = this.props.onCollapseExpandAccordion(row, hierarchyIndex, shiftKey, ctrlKey);
            }
        }
        return allowExpandAndCollapse;
    }

    onDisableClick(event: any) {
        const isChecked = $(event.currentTarget).is(":checked");
        this.setState({
            disabled: isChecked
        });
    }

    indexInHierarchyLevelData(row: any, hierarchyLevelData: HierarchyLevelData[]): number {
        if(null != this.props.rowKey) {
            for(let i = 0; i < hierarchyLevelData.length; i++) {
                if(hierarchyLevelData[i].rowKey == row[this.props.rowKey]) {
                    return i;
                }
            }
        }
        return -1;
    }

    parentIndexInHierarchyLevelData(row: any, hierarchyLevelData: HierarchyLevelData[]): number {
        if(null != row && null != hierarchyLevelData && null != this.props.rowKey) {
            const rowKey = row[this.props.rowKey];
            for(let i = 0; i < hierarchyLevelData.length; i++) {
                if((hierarchyLevelData[i].parentKey == "-1" && hierarchyLevelData[i].rowKey == rowKey) || hierarchyLevelData[i].parentKey == rowKey) {
                    return i;
                }
            }
        }
        return -1;
    }

    indexOfPagingData(hierarchyKey: string, pagingData: HierarchyPagingData[]): number {
        if(null != pagingData) {
            for(let i = 0; i < pagingData.length; i++) {
                if(pagingData[i].hierarchyKey == hierarchyKey) {
                    return i;
                }
            }
        }
        return -1;
    }

    getHierarchyLevelData(rowKey: string, parentKey: string, levelCount: number, rowList: any[]):HierarchyLevelData[] {
        const returnData: HierarchyLevelData[] = [];

        for (let i = 0; i < rowList.length; i++) {
            if (rowList[i][this.props.rowKey] == rowKey) {
                returnData.push({rowKey: rowKey, parentKey: parentKey, level: levelCount, index: i});
                return returnData;
            } else {
                if (null != rowList[i][this.props.hierarchyKey] &&
                    rowList[i][this.props.hierarchyKey].length > 0
                ) { // Has Children
                    const subParentKey = rowList[i][this.props.rowKey];
                    const childReturnData = this.getHierarchyLevelData(rowKey, subParentKey, levelCount + 1, rowList[i][this.props.hierarchyKey]);
                    if (null != childReturnData) {
                        for (let j = 0; j < childReturnData.length; j++) {
                            returnData.push(childReturnData[j]);
                        }
                        returnData.push({
                            rowKey: subParentKey,
                            parentKey: parentKey,
                            level: levelCount,
                            index: i
                        });
                        return returnData;
                    }
                }
            }
        }

        return null;
    }

    getRowWithRow(rowToFind: any, rowList: any[]):any {
        for(let i = 0; i < rowList.length; i++) {
            if(rowList[i] == rowToFind) {
                return rowList[i];
            } else {
                if(null != rowList[i][this.props.hierarchyKey] && rowList[i][this.props.hierarchyKey].length > 0) {
                    const returnRow = this.getRowWithRow(rowToFind, rowList[i][this.props.hierarchyKey]);
                    if(null != returnRow) {
                        return returnRow;
                    }
                }
            }
        }

        return null;
    }

    updateManualPageIndex(manualStartPos: number, hierarchyKey: string, mouseScroll: boolean): boolean {
        const index = this.indexOfPagingData(hierarchyKey, (this.state as ReactHierarchicalListState).updatedPagingData);
        if(index > -1) {
            if((this.state as ReactHierarchicalListState).updatedPagingData[index].startPos != manualStartPos) {
                (this.state as ReactHierarchicalListState).updatedPagingData[index].startPos = manualStartPos;
            } else {
                return false;
            }
        } else {
            (this.state as ReactHierarchicalListState).updatedPagingData.push({startPos: manualStartPos, hierarchyKey: hierarchyKey});
        }

        this.setState({
            updatedPagingData: (this.state as ReactHierarchicalListState).updatedPagingData,
            rowIsClicked: false,
        });

        return true;
    }

    updateCurrentPageIndex(currentStartPos: number, hierarchyKey: string) {
        const index = this.indexOfPagingData(hierarchyKey, this.currentPagingData);
        if(index > -1) {
            this.currentPagingData[index].startPos = currentStartPos;
        } else {
            this.currentPagingData.push({startPos: currentStartPos, hierarchyKey: hierarchyKey});
        }
    }

    getTotal(rows: any[]) {
        let count = 0;
        for (let i = 0; i < rows.length; i++) {
            const row = rows[i];
            if (null != this.props.hierarchyKey && null != row[this.props.hierarchyKey] && (row[this.props.hierarchyKey] as any[]).length > 0) {
                count = count + this.getTotal(row[this.props.hierarchyKey]);
            }
            count = count + 1;
        }
        return count;
    }

    render() {
        this.totalRows = [];
        this.foundPrevRow = false;
        this.returnNextRow = false;
        this.foundParentRow = false;
        this.foundCurrentRow = false;

        return <div id={this.props.id} className={this.props.css} style={this.props.style} onKeyDown={this.onKeyDown} onKeyUp={this.onKeyUp} tabIndex={this.props.tabIndex}>
            <div className={this.props.divContainerCSS} style={this.props.divContainerStyle}>
                {<table className="categoryAllHide">
                    <tr>
                        <td><input id={this.props.id + "_highlight"} onClick={this.highlightRow} value={(this.state as ReactHierarchicalListState).highlightKey} autoComplete="off" ></input></td>
                        <td>
                            HIDDEN HIGHLIGHT INDEX
                        </td>

                        <td><input id={this.props.hiddenTotalCountID} value={this.getTotal((this.state as ReactHierarchicalListState).rows)} autoComplete="off"/>
                        </td>
                        <td>
                            HIDDEN TOTAL COUNT
                        </td>
                    </tr><tr>
                    <td><input
                        id={this.props.disableID}
                        type="checkbox"
                        onChange={this.onDisableClick}
                        checked={(this.state as ReactHierarchicalListState).disabled}
                    /></td>
                    <td>
                        HIDDEN DISABLE BUTTON
                    </td>
                </tr>
                    <tr>
                        <td><button type="button" id={this.props.id + "_up"} onClick={event => {this.onKeyDown(new KeyboardEvent('keyup', { key: 'ArrowUp'}))}}>HIDDEN UP BUTTON</button></td>
                        <td><button type="button" id={this.props.id + "_down"} onClick={event => {this.onKeyDown(new KeyboardEvent('keydown', { key: 'ArrowDown'}))}}>HIDDEN DOWN BUTTON</button></td>
                        <td><button type="button" id={this.props.id + "_left"} onClick={event => {this.onKeyDown(new KeyboardEvent('keyleft', { key: 'ArrowLeft'}))}}>HIDDEN LEFT BUTTON</button></td>
                        <td><button type="button" id={this.props.id + "_right"} onClick={event => {this.onKeyDown(new KeyboardEvent('keyright', { key: 'ArrowRight'}))}}>HIDDEN RIGHT BUTTON</button></td>
                        <td><button type="button" id={this.props.id + "_scrollIntoView"} onClick={this.executeScroll}>SCROLL INTO VIEW BUTTON</button></td>
                    </tr>
                </table>
                }
                {getReactButton({id: this.props.refreshID, css: "categoryAllHide", onClick: this.onRefresh, text: "HIDDEN REFRESH BUTTON"})}
                {(this.state as ReactHierarchicalListState).rows.map((row) => {
                    const countData = {childCount: 0};
                    return this.getAccordionRow(row, false, countData, (this.state as ReactHierarchicalListState).selectedHierarchyLevelData, 0);
                })}
                {
                    this.getAccordionRow({isBottomRow: true, isHiddenDragRow: true, hiddenParentRow: null}, true, {childCount: 0}, (this.state as ReactHierarchicalListState).selectedHierarchyLevelData, 0)
                }
            </div>
        </div>;
    }
}
